import { RouteInfo } from './sidebar.metadata';

export const USER_ROUTES: RouteInfo[] = [
  {
    path: '/full-layout/events/all',
    title: 'ALL_EVENTS',
    icon: 'ft-shopping-cart',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  }
];

export const ADMIN_ROUTES: RouteInfo[] = [
  {
    path: '/full-layout/booking/table',
    title: 'Booking Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  }
];

export const ADMIN_EVENT_ORDER: RouteInfo[] = [
  {
    path: '/full-layout/ordering/table',
    title: 'Orders Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  }
];

export const ADMIN_EVENT_REGIS: RouteInfo[] = [
  {
    path: '/full-layout/registry/table',
    title: 'Registry Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  }
];

export const SUPERADMIN_ROUTES: RouteInfo[] = [
  {
    path: '/full-layout/booking/table',
    title: 'Booking Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/full-layout/ordering/table',
    title: 'Orders Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/full-layout/registry/table',
    title: 'Registry Table',
    icon: 'icon-notebook',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/full-layout/events/all',
    title: 'Events List',
    icon: 'ft-clipboard',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/full-layout/add-events',
    title: 'Add Events',
    icon: 'ft-film',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/full-layout/userSetup',
    title: 'User Setup',
    icon: 'ft-user',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  }
  // {
  //   path: '/full-layout',
  //   title: 'Full Layout',
  //   icon: 'ft-layout',
  //   class: '',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: false,
  //   submenu: []
  // },
  // {
  //   path: '/changelog',
  //   title: 'ChangeLog',
  //   icon: 'ft-file',
  //   class: '',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: false,
  //   submenu: []
  // },
  // {
  //   path: '/full-layout/dashboard2',
  //   title: 'Dashboard',
  //   icon: 'ft-film',
  //   class: '',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: false,
  //   submenu: []
  // },
  // {
  //   path: '/full-layout/events/add',
  //   title: 'Add Events',
  //   icon: 'ft-film',
  //   class: '',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: false,
  //   submenu: []events/all
  // },

  // {
  //   path: 'https://pixinvent.ticksy.com/',
  //   title: 'Support',
  //   icon: 'ft-life-buoy',
  //   class: '',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: true,
  //   submenu: []
  // }
];
